import type { DonorPrizeStatus, RoulettePrizeType } from '@/lib/roulette'

export interface DistributedPrizesFiltersState {
  status: DonorPrizeStatus | ''
  prizeType: RoulettePrizeType | ''
  email: string
  dateFrom: string
  dateTo: string
}

export function getDefaultDistributedPrizesFilters(): DistributedPrizesFiltersState {
  return {
    status: '',
    prizeType: '',
    email: '',
    dateFrom: '',
    dateTo: '',
  }
}

export function hasActiveDistributedPrizesFilters(
  filters: DistributedPrizesFiltersState
): boolean {
  return (
    filters.status !== '' ||
    filters.prizeType !== '' ||
    filters.email.trim() !== '' ||
    filters.dateFrom !== '' ||
    filters.dateTo !== ''
  )
}

export type DistributedPrizesDateRangeIssue = 'none' | 'incomplete' | 'inverted'

export function getDistributedPrizesDateRangeIssue(
  filters: DistributedPrizesFiltersState
): DistributedPrizesDateRangeIssue {
  const hasFrom = filters.dateFrom !== ''
  const hasTo = filters.dateTo !== ''
  if (!hasFrom && !hasTo) return 'none'
  if (hasFrom !== hasTo) return 'incomplete'
  if (filters.dateFrom > filters.dateTo) return 'inverted'
  return 'none'
}

export function isDistributedPrizesDateRangeValid(
  filters: DistributedPrizesFiltersState
): boolean {
  return getDistributedPrizesDateRangeIssue(filters) === 'none'
}

export function distributedPrizesDateRangeErrorMessage(
  issue: DistributedPrizesDateRangeIssue
): string | null {
  if (issue === 'incomplete') {
    return 'Preencha data inicial e final juntas ou limpe as duas datas.'
  }
  if (issue === 'inverted') {
    return 'A data final deve ser igual ou posterior à inicial.'
  }
  return null
}
